
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/[slug]",
      function () {
        return require("private-next-pages/integrations/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/[slug]"])
      });
    }
  